/**
 * Zustand runtime-info store.
 *
 * Caches the server's safe model availability and active-job count.
 */
import { create } from 'zustand';
import { runtimeInfoApi } from '../api/endpoints/runtime-info';
import type { RuntimeGenerationModelOption } from '../utils/generation-models';

export interface RuntimeInfo {
  model: string;
  reasoning: string;
  streaming: boolean;
  activeJobs: number;
  /** null = no cap. */
  maxJobs: number | null;
  generationModels?: RuntimeGenerationModelOption[];
}

interface RuntimeState {
  runtimeInfo: RuntimeInfo | null;
  refresh: () => Promise<void>;
}

export const useRuntimeStore = create<RuntimeState>((set) => ({
  runtimeInfo: null,

  async refresh() {
    try {
      const response = await runtimeInfoApi.get();
      const { ok: _ok, ...info } = response as RuntimeInfo & { ok: true };
      set({ runtimeInfo: info as RuntimeInfo });
    } catch {
      // Non-critical: runtime info is display-only. Silently retry on next poll.
    }
  },
}));
